// extracted by mini-css-extract-plugin
export default {"paypal":"styles_paypal__PwlWS"};